<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">The Still</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?527c7536